import { Record } from 'immutable';
import { getOr } from 'lodash/fp';
import * as types from './actionTypes';
import constants from '../constants';

const outreachFormDefault = {
  dealerId: null,
  templateId: null,
  enabled: true,
  values: null,
};

const outreachFormsDefault = [];

const requestReducerState = Record({
  outreachForm: { ...outreachFormDefault },
  outreachForms: [...outreachFormsDefault],
  [constants.ERROR_KEY]: null,
  [constants.FETCHING_KEY]: false,
});

export default (state = requestReducerState(), action) => {
  const { type, payload } = action;
  switch (type) {
    case types.OUTREACH_FORM_REQUEST:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, true)
        .set('outreachForms', [...outreachFormsDefault]);

    case types.OUTREACH_FORMS_STATUS_REQUEST:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, true)
        .set('outreachForm', { ...outreachFormDefault });

    case types.UPDATE_OUTREACH_FORM_REQUEST:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, true);

    case types.OUTREACH_FORM_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('outreachForm', payload);

    case types.OUTREACH_FORMS_STATUS_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('outreachForms', getOr(payload, 'data')(payload));

    case types.UPDATE_OUTREACH_FORM_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('outreachForm', payload);

    case types.OUTREACH_FORM_FAILURE:
    case types.OUTREACH_FORMS_STATUS_FAILURE:
    case types.UPDATE_OUTREACH_FORM_FAILURE:
      return state
        .set(constants.FETCHING_KEY, false)
        .set(constants.ERROR_KEY, action.payload);

    default:
      return state;
  }
};
